import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-second-calender',
  templateUrl: './second-calender.component.html',
  styleUrls: ['./second-calender.component.scss']
})
export class SecondCalenderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
